import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import PageLoader from "./../../../../assets/loading/pageLoad1.gif"

const EditCcSpoiledPurchase = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [record, setRecord] = useState({})
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [vendors, setVendors] = useState([])
  const [reason, setReason] = useState("")

  useEffect(() => { getInfo() }, [])

  const getInfo = async () => {
    try {
      const [recResp, chilResp, rouResp, ccResp, venResp] = await Promise.all([
        api.get("cc-spoiled-purchase/" + id), api.get("centers?per_page=500"),
        api.get("routes?per_page=500"), api.get("collection-centers?per_page=500"),
        api.get("vendors?per_page=500")
      ])
      const data = recResp.data.data[0] || {}
      setRecord(data)
      setReason(data.reason || "")
      const extract = (r) => { const d = r.data?.data; return Array.isArray(d) ? d : d?.data || [] }
      setChillings(extract(chilResp)); setRoutes(extract(rouResp))
      setCollections(extract(ccResp)); setVendors(extract(venResp))
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true); setSubmitted(false)
    try {
      const resp = await api.put("update-cc-spoiled-purchase/" + id, values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit Spoiled Purchase</h4></Col>
          <Col md={6} style={{textAlign:"right"}}><Link to="/cc-spoiled-purchases" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
          <h6 style={{color:"#ef4444",borderBottom:"2px solid #fecaca",paddingBottom:"8px",marginBottom:"16px"}}><i className="fas fa-map-marker-alt"></i> Location</h6>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center" required value={String(record.chillingCenter||"")}>
              <option value="">Select</option>{chillings.map((c,i)=><option key={i} value={String(c.id)}>{c.name}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route" required value={String(record.route||"")}>
              <option value="">Select</option>{routes.map((r,i)=><option key={i} value={String(r.id)}>{r.routeName}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="collectionCenter" label="Collection Center" required value={String(record.collectionCenter||"")}>
              <option value="">Select</option>{collections.map((c,i)=><option key={i} value={String(c.id)}>{c.centerName}</option>)}
            </AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="vendor" label="Vendor" value={String(record.vendor||"")}>
              <option value="">Select</option>{vendors.map((v,i)=><option key={i} value={String(v.id)}>{v.vendorName||v.name}</option>)}
            </AvField></div></Col>
          </Row>

          <h6 style={{color:"#ef4444",borderBottom:"2px solid #fecaca",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-exclamation-triangle"></i> Spoilage Details</h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="spoiledDate" label="Spoiled Date" type="date" value={record.spoiledDate} required /></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="shift" label="Shift" value={String(record.shift)} required errorMessage="Pick one!"><AvRadio label="AM" value="0" /><AvRadio label="PM" value="1" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="milkType" label="Milk Type" value={String(record.milkType)} required errorMessage="Pick one!"><AvRadio label="Cow" value="1" /><AvRadio label="Buffalo" value="2" /><AvRadio label="Common" value="3" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="reason" label="Reason" required value={record.reason} onChange={e=>setReason(e.target.value)}>
                <option value="">Select</option>
                <option value="adulteration">Adulteration</option><option value="sour">Sour/Curdled</option>
                <option value="foreign_matter">Foreign Matter</option><option value="expired">Expired</option>
                <option value="low_quality">Low Quality</option><option value="other">Other</option>
              </AvField>
            </div></Col>
            {reason === "other" && <Col md={8}><div className="mb-3"><AvField name="reasonDetails" label="Reason Details" type="textarea" rows="2" value={record.reasonDetails} required /></div></Col>}
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="actionTaken" label="Action Taken" required value={record.actionTaken}>
                <option value="">Select</option>
                <option value="returned">Returned</option><option value="discarded">Discarded</option><option value="reprocessed">Reprocessed</option>
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3"><AvField name="reportedBy" label="Reported By" type="text" value={record.reportedBy} required /></div></Col>
          </Row>

          <h6 style={{color:"#ef4444",borderBottom:"2px solid #fecaca",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-flask"></i> Quantity & Quality</h6>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="qtyLtrs" label="Ltrs" type="number" step="0.01" value={record.qtyLtrs} required /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="qtyKg" label="KG" type="number" step="0.01" value={record.qtyKg} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseFat" label="FAT" type="number" step="0.01" value={record.purchaseFat} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseSnf" label="SNF" type="number" step="0.01" value={record.purchaseSnf} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseClr" label="CLR" type="number" step="0.01" value={record.purchaseClr} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="ratePerLtr" label="Rate/Ltr" type="number" step="0.01" value={record.ratePerLtr} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="estimatedLoss" label="Est. Loss (₹)" type="number" step="0.01" value={record.estimatedLoss} /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Spoiled Purchase Updated!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-danger w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{paddingLeft:"10px"}}>Updating...</span></> : <span><i className="fas fa-save"></i> Update Record</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default EditCcSpoiledPurchase
